export { LegalFooter } from "./legal-footer";
